import { info } from "../../data/personal";

import yuva from "../../assets/images/profile/profile.jpg";
import rotate from "../../assets/images/logo/rotate.svg";
import logo from "../../assets/images/logo/ydw.png";

import GitHubIcon from "@mui/icons-material/GitHub";

function Home() {
  return (
    <section className="hero" id="home">
      <div className="container">
        <div className="hero-banner">
          <img
            src={yuva}
            width="800"
            height="864"
            loading="lazy"
            alt="Yuva's "
            className="img-cover"
          />

          <div className="elem elem-1">
            <p className="elem-title">{info.cgpa}</p>
            <p className="elem-text">CGPA</p>
          </div>

          <a href={info.gihub}>
            <div className="elem elem-2">
              <GitHubIcon fontSize="large" />
              <p className="elem-text"> My Work</p>
            </div>
          </a>

          <div className="elem elem-3">
            <img src={logo} width={"60"} alt="custom-logo" />
          </div>

          <img
            src={rotate}
            width="auto"
            height="auto"
            alt="I'm developer"
            className="rotate-img"
          />
        </div>

        <div className="hero-content">
          <h2 className="hero-title">
            <span>Hello I'm</span>
            <strong>{info.Name}</strong> Web Developer
          </h2>
          <p className="hero-text">
            A self-motivated, self-taught web developer.Quest to work and learn
            in a real professional and vying ambience that enables me to cope
            with the emerging as well as latest technology and scope for
            widening the spectrum of my knowledge.
          </p>

          <div className="btn-group">
            <a href="#contact" className="btn btn-primary blue">
              Let's Connect
            </a>

            <a href="#about" className="btn">
              About Me
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
export default Home;
